module.exports = __webpack_public_path__ + "static/empowering-33cb9b67fb8e7893936be87ca777849f.jpg";